export enum PaymentStatus {
  NotInitialized = 'NotInitialized',
  ReadyToBePaid = 'ReadyToBePaid',
  PartiallyPaid = 'PartiallyPaid',
  Paid = 'Paid',
  OverPaid = 'OverPaid',
  Dunning = 'Dunning',
}
